import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { looseDiamondId, looseStoneId } from "utils/helpers";

const data4 = [
  {
    srNo: "01",
    itemDetails: "Purchase Gold, Bangles, Navratna Bang, BN100",
    totalWt: "100.000",
    grossWt: "800.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "2",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "10.000",
    diamondWt: "121.000",
  },
  {
    srNo: "02",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "03",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "04",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
];
const totals = data4.reduce(
  (acc, row) => {
    acc.totalWt += parseFloat(row.totalWt);
    acc.grossWt += parseFloat(row.grossWt);
    acc.stoneWt += parseFloat(row.stoneWt);
    acc.netWt += parseFloat(row.netWt);
    acc.finePercent += parseFloat(row.finePercent);
    acc.wastagePercent += parseFloat(row.wastagePercent);
    acc.fPlusWWt += parseFloat(row.fPlusWWt);
    acc.stoneAmt += parseFloat(row.stoneAmt);
    acc.qty += parseFloat(row.qty);
    acc.hallmarkAmt += parseFloat(row.hallmarkAmt);
    acc.totalItemAmt += parseFloat(row.totalItemAmt.replace(/,/g, ""));
    acc.packingWt += parseFloat(row.packingWt);
    acc.diamondWt += parseFloat(row.diamondWt);
    return acc;
  },
  {
    totalWt: 0,
    grossWt: 0,
    stoneWt: 0,
    netWt: 0,
    finePercent: 0,
    wastagePercent: 0,
    fPlusWWt: 0,
    stoneAmt: 0,
    qty: 0,
    hallmarkAmt: 0,
    totalItemAmt: 0,
    packingWt: 0,
    diamondWt: 0,
  }
);

const StoneSummary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
}) => {
  const [total, setTotal] = useState({
    TotalStoneWt: 0,
    TotalStonePieces: 0,
    TotalStoneAmount: 0,
  });
  const handleDelete = (id) => {
    setValue(
      "skus",
      skus.filter((sku) => sku.id !== id)
    );
  };
  const handleEdit = (id) => {
    const data = skus.find((sku) => sku.id == id);
    setEditValues(data);
    setEdit(true);
    setIsSummaryOpen(false);
  };

  useEffect(() => {
    let totalWt = 0;
    let stonePieces = 0;
    let stoneAmount = 0;

    skus?.forEach((item) => {
      totalWt += +item?.StoneWeight;
      stonePieces += +item?.StonePieces;
      stoneAmount += +item?.StoneAmount;
    });

    setValue("TotalTaxableAmount", stoneAmount?.toFixed(3));

    setTotal({
      TotalStoneWt: totalWt ? totalWt : 0,
      TotalStonePieces: stonePieces ? stonePieces : 0,
      TotalStoneAmount: stoneAmount ? stoneAmount : 0,
    });
  }, [skus]);
  console.log(skus);
  return (
    <div className="box1-section">
      <div
        className="table-container"
        style={{ overflowX: "auto", margin: "0", padding: "0", width: "100%" }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  width: "200px",
                  minWidth: "200px",
                  textAlign: "left",
                }}
              >
                Item Details
              </th>
              <th style={{ fontSize: "12px" }}>Stone Name</th>
              <th style={{ fontSize: "12px" }}>Shape</th>
              <th style={{ fontSize: "12px" }}>Color</th>
              <th style={{ fontSize: "12px" }}>Size</th>
              <th style={{ fontSize: "12px" }}>Weight</th>
              <th style={{ fontSize: "12px" }}>Rate/karate</th>
              <th style={{ fontSize: "12px" }}>Pieces</th>
              <th style={{ fontSize: "12px" }}>Rate/Piece</th>
              <th style={{ fontSize: "12px" }}>Amount</th>
              <th style={{ fontSize: "12px" }}>Setting Type</th>
              <th style={{ fontSize: "12px" }}>Certificate</th>
              <th style={{ fontSize: "12px" }}>Description</th>
            </tr>
          </thead>
          <tbody>
            {skus.map((row) => (
              <tr key={row.srNo}>
                <td>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "12px",
                      // gap: "5px",
                    }}
                  >
                    <Icon
                      icon="lets-icons:img-box-fill"
                      width="24"
                      height="24"
                      style={{ flex: "1", color: "#627282", cursor: "pointer" }}
                    />
                    <div style={{ flex: "1" }}>
                      {row?.CategoryId?.value !== looseStoneId &&
                      row?.CategoryId?.value !== looseDiamondId ? (
                        <>
                          {row?.CategoryId?.label} - {row?.ProductId?.label} -{" "}
                          {row?.DesignId?.label} - {row?.PurityId?.label}
                        </>
                      ) : row?.CategoryId?.value == looseStoneId ||
                        row?.CategoryId?.value == looseDiamondId ? (
                        row?.CategoryId?.label
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="edit"
                        onClick={() => handleEdit(row.id)}
                      >
                        <Icon
                          title="edit"
                          icon="material-symbols-light:edit-outline"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                        />
                      </div>
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="delete"
                      >
                        <Icon
                          icon="weui:delete-outlined"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                          onClick={() => {
                            handleDelete(row.id);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneName}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneShape?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneColour?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneSize}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneWeight}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneRateCt}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StonePieces}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneRatePc}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneAmount}
                </td>

                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneSettingType?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneCertificate}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.StoneDescription}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "12px",
                    gap: "5px",
                  }}
                >
                  <div></div>
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    title="add more"
                  >
                    <Icon
                      icon="weui:add-outlined"
                      onClick={() => {
                        // reset
                        setEdit(false);
                        setIsSummaryOpen(false);
                      }}
                      width="15"
                      height="15"
                      style={{ color: "#627282", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                Total
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalStoneWt?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalStonePieces?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalStoneAmount?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StoneSummary;
